module.exports = __webpack_public_path__ + "img/all_active.2eae454b.svg";